import { useState, useEffect, useRef } from 'react';
import { Search, Filter } from 'lucide-react';
import './FiltrosFactuBox.css';

/**
 * Componente de filtros para FactuBox
 * @param {Object} filtros - Objeto con valores actuales de filtros
 * @param {Function} onChange - Callback para actualizar filtros
 * @param {Boolean} esNotasCredito - Si true, oculta filtro de estado DIAN
 */
function FiltrosFactuBox({ filtros, onChange }) {
  const [busquedaLocal, setBusquedaLocal] = useState(filtros.busqueda || '');
  const debounceTimerRef = useRef(null);

  // Debounce para búsqueda (300ms)
  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      if (busquedaLocal !== filtros.busqueda) {
        onChange({
          ...filtros,
          busqueda: busquedaLocal
        });
      }
    }, 300);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [busquedaLocal]);

  // Sincronizar búsqueda local cuando cambien filtros externos
  useEffect(() => {
    if (filtros.busqueda !== busquedaLocal) {
      setBusquedaLocal(filtros.busqueda || '');
    }
  }, [filtros.busqueda]);

  const handleChange = (field, value) => {
    onChange({
      ...filtros,
      [field]: value
    });
  };

  return (
    <div className="filtros-factubox">
      <div className="filtros-factubox__row">
        {/* Rango de fechas */}
        <div className="filtro-grupo">
          <label htmlFor="fecha_inicio">Desde</label>
          <input
            type="date"
            id="fecha_inicio"
            value={filtros.fecha_inicio || ''}
            onChange={(e) => handleChange('fecha_inicio', e.target.value)}
          />
        </div>

        <div className="filtro-grupo">
          <label htmlFor="fecha_fin">Hasta</label>
          <input
            type="date"
            id="fecha_fin"
            value={filtros.fecha_fin || ''}
            onChange={(e) => handleChange('fecha_fin', e.target.value)}
          />
        </div>

        {/* Búsqueda con debounce */}
        <div className="filtro-grupo filtro-grupo--busqueda">
          <label htmlFor="busqueda">Buscar</label>
          <div className="input-with-icon">
            <Search size={18} />
            <input
              type="text"
              id="busqueda"
              placeholder="Buscar por número, cliente..."
              value={busquedaLocal}
              onChange={(e) => setBusquedaLocal(e.target.value)}
            />
          </div>
        </div>

      </div>
    </div>
  );
}

// Optimización: Evitar re-renders si las props no cambian
export default FiltrosFactuBox;
